const loadCursore = (state = {load: false}, action) => {
  switch (action.type) {
    case 'LOAD_CURSORE_SET':
      return {load: action.data}
    default:
      return state
  }
}

export default loadCursore;


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/redux/reducers/loadCursore.js